module.exports = __webpack_public_path__ + "img/blue_165.6ad38905.png";